import { defineMessages } from 'react-intl';

export default defineMessages({
    usernameEmail: {
        id: 'tdic.tnc.user.email.My Email Address for TDIC Policy Notifications',
        defaultMessage: 'Email Address for TDIC Policy Notifications'
    },
    tncAcceptance: {
        id: 'tdic.tnc.user.email.By clicking on this signature box, I authorize this email address to be updated in my account profile and used for my TDIC policy notifications in accordance with the {link}.',
        defaultMessage: 'By clicking on this signature box, I authorize this email address to be updated in my account profile and used for my TDIC policy notifications in accordance with the {link}.'

    },
    userEmailTextMessage: {
        id: 'tdic.tnc.user.email.Please confirm or update the named insured email address so that we may provide you information related to your TDIC coverage in electronic format for any policy where you are the named insured.',
        defaultMessage: 'Please confirm or update the named insured email address so that we may provide you information related to your TDIC coverage in electronic format for any policy where you are the named insured.'
    },

    termsOfConditions: {
        id: 'tdic.tnc.user.email.Term of Use',
        defaultMessage: 'Term of Use'
    },
    tcSubmitButton: {
        id: 'tdic.tnc.user.email.Submit',
        defaultMessage: 'Save'
    },
    userEmailErrorMessage: {
        id: 'tdic.tnc.user.email.An error occurred attempting to submit the email.',
        defaultMessage: 'An error occurred attempting to submit the email.'
    },
    userEmailErrorTitle: {
        id: 'tdic.tnc.user.email.Unable to save email information',
        defaultMessage: 'Unable to save email information'
    },
    userEmailLoadErrorMessage: {
        id: 'tdic.tnc.user.email.An error occurred attempting to process your request',
        defaultMessage: 'An error occurred attempting to process your request'
    },
    userEmailLoadErrorTitle: {
        id: 'tdic.tnc.user.email.Unable to load requested data',
        defaultMessage: 'Unable to load requested data'
    },
    ok: {
        id: 'tdic.tnc.user.email.Ok',
        defaultMessage: 'Ok'
    }
});
